import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 11.2361v.8517H4.04069c-.003-.08-.005-.161-.005-.242 0-.5418.06797-1.0696.19693-1.5764.49582-1.95429 1.89432-3.6037 3.78565-4.58236L6.79171 3.42385c-.07598-.13895-.024-.31389.11495-.38886.13995-.07597.31389-.02399.38987.11496l1.24055 2.28918c1.05663-.45684 2.24222-.71374 3.49572-.71374 1.2436 0 2.4212.25291 3.4708.70475l1.2356-2.28019c.0759-.13895.2499-.19093.3898-.11496.139.07497.191.24991.116.38886l-1.2206 2.2512c1.9833 1.01864 3.4288 2.77501 3.8666 4.84725.05.2339.086.4719.109.7138zM9.13087 8.50904c0-.41485-.33588-.75073-.75073-.75073s-.75073.33588-.75073.75073.33588.75173.75073.75173.75073-.33688.75073-.75173zm7.27643 0c0-.41485-.3369-.75073-.7518-.75073-.4148 0-.7507.33588-.7507.75073s.3359.75173.7507.75173c.4149 0 .7518-.33688.7518-.75173z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9943 21.0851H4v-7.9972h15.9943v7.9972z",
    fill: "currentColor"
  }));
});